module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow-f7e93191d3caa452bcf9a2a7e78da0ca.webp";